<template>
  <div id='app'>
    <div class='app-phone vld-parent'>
      <loading :active.sync="isLoading"
    :can-cancel="false"
    :on-cancel="onCancel"
    :is-full-page="fullPage"></loading>
      <nav
      class="navbar is-dark is-transparent"
      role="navigation"
      aria-label="main navigation">
        <div class="navbar-brand">
          <a class="navbar-item" href="https://sabinov.online">
          <img src="https://sabinov.online/pwa/sbfoto_logo.png" alt="Sabinov.online - mobilná aplikácia" width="120" height="48">
         </a>
          <a role="button"
          class="navbar-burger burger"
          aria-label="menu"
          aria-expanded="false"
          data-target="sbnavigacia">
            <span></span>
            <span></span>
            <span></span>
          </a>
        </div>
        <div v-if='step === 2 || step === 3' class="navbar-menu is-active sb-subnav">
            <a class='cancel-cta'
              v-if='step === 2 || step === 3'
              @click='goToHome'>
                Zrušiť
            </a>
            <a class='next-cta'
              v-if='step === 2'
              @click='step++'>
                Ďalej
            </a>
            <a class='next-cta'
              v-if='step === 3'
              @click='sharePost'>
                Zdieľaj
            </a>
        </div>
        <div id="sbnavigacia" class="navbar-menu">
          <div class="navbar-end">
            <a class="navbar-item" @click="getPosts('ludia')">Ľudia</a>
            <a class="navbar-item" @click="getPosts('priroda')">Príroda</a>
            <a class="navbar-item" @click="getPosts('kultura')">Kultúra</a>
            <a class="navbar-item" @click="getPosts('sport')">Šport</a>
            <a class="navbar-item" @click="getPosts('zabava')">Zábava</a>
          </div>
        </div>
      </nav>
      <phone-body
        :step='step'
        :posts='posts'
        :filters='filters'
        :image='image'
        :selectedFilter='selectedFilter'
        :username.sync="username"
        :caption.sync="caption"
        :category.sync="category"
      />
      <div class='phone-footer'>
       <div class='home-cta' @click='goToHome'>
        <i class='fas fa-home fa-lg fa-2x'></i>
       </div>
       <p><a href="https://sabinov.online">Sabinov.online</a></p>
       <div class='upload-cta'>
          <input type='file'
            name='file'
            id='file'
            class='inputfile'
            @change='uploadImage'
            :disabled='step !== 1'
          />
          <label for='file'>
            <i class='far fa-plus-square fa-lg fa-2x'></i>
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

/* eslint-disable */

import PhoneBody from './components/PhoneBody';
import filters from './data/filters';
import EventBus from './event-bus';
import { APIService } from './APIService';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';

const apiService = new APIService();

export default {
  name: 'App',
  data() {
    return {
      step: 1,
      posts: [],
      filters,
      image: '',
      selectedFilter: '',
      caption: '',
      username: '',
      category: '',
      busy: false,
      isLoading: false,
      fullPage: true,
    };
  },
  beforeMount() {
    let jsonData = this.getPosts();
    if (jsonData !== undefined) {
      this.posts = JSON.parse(this.getPosts());
    }
  },  
  created() {
    EventBus.$on('filter-selected', (evt) => {
      this.selectedFilter = evt.filter;
    });
  },
  methods: {
    getPosts(kategoria='') { 
      this.isLoading = true;      
      apiService.loadPosts(kategoria).then(
        (data) => { 
          this.posts = data;
          this.isLoading = false;
        }
      ); 
    },    
    uploadImage(evt) {
      this.isLoading = true;
      const files = evt.target.files;
      if (!files.length) return;

      const reader = new FileReader();
      reader.onloadstart = function(event) {
          this.isLoading = true;
      };
      reader.onprogress = function(event) {
          if (event.lengthComputable) {
              if (!this.isLoading)
                  this.isLoading = true;
              console.log(event.lengthComputable);
          }
      };
      reader.onloadend = function(event) {
          this.isLoading = false;
      };
      reader.readAsDataURL(files[0]);      
      reader.onload = (readerEvt) => {
        this.image = readerEvt.target.result;
        this.step = 2;
      };
      this.isLoading = false;
      document.querySelector('#file').value = '';
    },
    sharePost() {
      this.isLoading = true;                       
      apiService.uploadFile(this.image)
      .then((response) => {
        const post = {
          username: this.username,
          userImage: apiService.getApiUrl()+'/user.png',
          postImage: response.data.image,
          likes: 0,
          caption: this.caption,
          filter: this.selectedFilter,
          category: this.category
        };      
        apiService.savePost(post);
        this.posts.unshift(post);        
        this.isLoading = false;
        this.goToHome();
      })
      .catch(function (response) {
        console.log(response);
      });            
    },
    goToHome() {
      this.image = '';
      this.selectedFilter = '';
      this.userEntry = {};
      this.step = 1;
    },
    onCancel() {
      console.log('Zruš loader.')
    }
  },
  components: {
    'phone-body': PhoneBody,
    Loading
  },
};
</script>

<style lang='scss' src='./styles/app.scss'>

</style>




// WEBPACK FOOTER //
// src/App.vue